import PropTypes from 'prop-types';

import { useChannelTypes } from '../../../models/channels/queries';
import { resolveChannelIcon } from '../../../utils/channelIcons';

const COLOR_BY_SLUG = {
	email: 'bg-primary-200 text-primary-700',
	phone_manual: 'bg-success-200 text-success-700',
	manual_custom: 'bg-bgBase-400 text-bgBase-800',
	phone_ai: 'bg-primary-100 text-primary-600',
	letter: 'bg-caution-200 text-caution-700',
	linkedin: 'bg-bgBase-400 text-primary-700',
};

/**
 * Lightweight badge for a channelTypeId. Looks up the slug via useChannelTypes
 * (cached), falls back to a generic "Kanal" if the id is unknown.
 */
const ChannelBadge = ({ channelTypeId, size = 'sm' }) => {
	const { data: channels = [] } = useChannelTypes(true);
	const ch = channels.find((c) => c.id === channelTypeId);
	if (!ch) return null;

	const Icon = resolveChannelIcon(ch);
	const colorClass = COLOR_BY_SLUG[ch.slug] ?? 'bg-bgBase-300 text-text';
	const sizeClass = size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';

	return (
		<span className={`inline-flex items-center gap-1 rounded-full ${colorClass} ${sizeClass}`}>
			<Icon className="w-3 h-3" />
			{ch.displayName}
		</span>
	);
};

ChannelBadge.propTypes = {
	channelTypeId: PropTypes.string,
	size: PropTypes.oneOf(['xs', 'sm']),
};

export default ChannelBadge;
